import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "renderTitle", "icon", "iconAnimation", "isSelected", "openKeys", "selectedKeys", "data", "level", "parent", "onItemClick", "onItemSelected"];
import React, { useCallback, useMemo } from 'react';
import { CSSTransition } from 'react-transition-group';
import Icon from '@uiw/react-icon';
import { noop } from '@uiw/utils';
import { getChildKeys } from './';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Label = _ref => {
  var {
    label,
    className
  } = _ref;
  return useMemo(() => /*#__PURE__*/_jsx("span", {
    className: className,
    children: label
  }), [label]);
};
export default function TreeNode(props) {
  var {
      prefixCls,
      renderTitle,
      icon,
      iconAnimation,
      isSelected,
      openKeys,
      selectedKeys,
      data,
      level,
      parent,
      onItemClick = noop,
      onItemSelected = noop
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  var isOpen = false;
  var node = React.useRef(null);
  if (parent && (parent.key || parent.key === 0)) {
    isOpen = !!(openKeys && openKeys.indexOf(parent.key) > -1);
  }
  var onExit = useCallback(() => {
    node.current.style.height = node.current.scrollHeight + "px";
  }, []);
  var onExiting = useCallback(() => {
    node.current.style.height = '1px';
  }, []);
  var onEnter = useCallback(() => {
    node.current.style.height = '1px';
  }, []);
  var onEntering = useCallback(() => {
    node.current.style.height = node.current.scrollHeight + "px";
  }, []);
  var onEntered = useCallback(() => {
    node.current.style.height = 'initial';
  }, []);
  return /*#__PURE__*/_jsx(CSSTransition, {
    nodeRef: node,
    classNames: prefixCls,
    in: isOpen,
    timeout: 200,
    onExit: onExit,
    onExiting: onExiting,
    onEnter: onEnter,
    onEntered: onEntered,
    onEntering: onEntering,
    children: /*#__PURE__*/_jsx("ul", {
      ref: node,
      className: [level !== 1 && isOpen ? [prefixCls + "-open"] : null, level !== 1 && !isOpen ? [prefixCls + "-close"] : null].filter(Boolean).join(' ').trim(),
      children: data.map((item, idx) => {
        item.parent = parent;
        var selected = !!(selectedKeys && selectedKeys.indexOf(item.key) > -1);
        var noChild = !item.children;
        var itemIsOpen = openKeys && openKeys.indexOf(item.key) > -1 && !!item.children;
        var iconItem = typeof icon === 'function' ? icon(item, {
          isOpen: !!itemIsOpen,
          noChild,
          openKeys,
          selectedKeys
        }) : icon;
        var childKeys = noChild ? [] : getChildKeys(item.children);
        var checkedKeys = selectedKeys ? selectedKeys.filter(key => childKeys.indexOf(key) > -1) : [];
        var isHalfChecked = checkedKeys.length > 0 && childKeys.length !== checkedKeys.length;
        var disabledObj = {
          onClick: onItemSelected,
          disabled: null,
          disabledMouse: null,
          disabledClass: undefined,
          disabledStyle: undefined
        };
        if (item.disabled) {
          disabledObj.onClick = undefined;
          disabledObj.disabled = 'disabled';
          disabledObj.disabledMouse = prefixCls + "-disabled-mouse";
          disabledObj.disabledClass = prefixCls + "-disabled-ele";
          disabledObj.disabledStyle = {
            color: '#00000040'
          };
        }
        return /*#__PURE__*/_jsxs("li", {
          style: {
            display: item.hideNode ? 'none' : 'block'
          },
          children: [/*#__PURE__*/_jsxs("div", {
            className: prefixCls + "-label",
            children: [/*#__PURE__*/_jsx("span", {
              style: {
                display: noChild ? 'none' : 'auto'
              },
              className: prefixCls + "-switcher",
              onClick: evn => onItemClick(item, evn),
              children: /*#__PURE__*/_jsx(Icon, {
                type: iconItem || 'caret-right',
                className: [typeof icon === 'function' ? prefixCls + "-switcher-noop" : null, noChild ? 'no-child' : null, !iconAnimation ? 'no-animation' : null, itemIsOpen ? 'open' : null].filter(Boolean).join(' ').trim()
              })
            }), /*#__PURE__*/_jsx("div", {
              onClick: evn => disabledObj.onClick == null ? void 0 : disabledObj.onClick(item, evn),
              className: [prefixCls + "-title", selected && isSelected ? 'selected' : null, disabledObj.disabled, disabledObj.disabledMouse].filter(Boolean).join(' ').trim(),
              children: renderTitle ? renderTitle(item, {
                selected,
                noChild,
                openKeys,
                isHalfChecked,
                selectedKeys,
                disabled: item.disabled,
                disabledClass: disabledObj.disabledClass,
                disabledStyle: disabledObj.disabledStyle
              }) : /*#__PURE__*/_jsx(Label, {
                label: item.label,
                className: disabledObj.disabledClass
              })
            })]
          }), item.children && /*#__PURE__*/_jsx(TreeNode, _extends({}, other, {
            prefixCls,
            icon,
            iconAnimation,
            isSelected,
            openKeys,
            selectedKeys,
            onItemClick,
            onItemSelected,
            renderTitle,
            prefixCls: prefixCls,
            data: item.children,
            level: level + 1,
            parent: item
          }))]
        }, idx);
      })
    })
  });
}